import env from '../../package.json'
import $api from "http";


export default class TaskStatusService {
    static getStatus = async () => {
        const response = await $api.get(`${env.nodeHost}/api/task-status`)
        return response.data
    }
}